import * as React from 'react';
import { FixMeLater } from '../../utils';
import { EyeHideIcon } from '../../icons';
import { EyeRevealIcon } from '../../icons/EyeRevealIcon';
import { TextField, TextFieldProps } from '../TextField';

export type PasswordFieldProps = Omit<TextFieldProps, 'buttonIcon' | 'onButtonClick' | 'type'>;

/**
 * The following component PasswordField, is customised to be a Input field but just for use for passwords. It will allow entering
 * and validation of any input made with the field type being password to prevent the password being disaplyed on the screen. We can control
 * the size and variation of the field via props and also comes with the ability view the entered password upon clicking on the eye icon on the right.
 */
export const PasswordField: React.ForwardRefExoticComponent<PasswordFieldProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function PasswordField(
        props: PasswordFieldProps,
        ref: React.ForwardedRef<FixMeLater>
    ): React.JSX.Element {
        const [showPassword, setShowPassword] = React.useState(false);

        return (
            <TextField
                ref={ref}
                buttonIcon={showPassword ? <EyeHideIcon /> : <EyeRevealIcon />}
                onButtonClick={() => setShowPassword(!showPassword)}
                type={showPassword ? 'text' : 'password'}
                {...props}
            />
        );
    });
